import {
  getObjectKeysAsObject,
  setContextWithKey,
  ParentState,
} from "@hopper-b2b/checkout";
import { assign } from "xstate";
import {
  type PartialParentContextWithTermsAndConditions,
  termsAndConditionsStep,
} from "./context";
import type { ToggleAcceptedEvent } from "./events";

export const actions = {
  toggleAccepted: assign(
    (
      ctx: PartialParentContextWithTermsAndConditions,
      _event: ToggleAcceptedEvent
    ) =>
      setContextWithKey(
        ctx,
        `${ParentState.review}.${termsAndConditionsStep}.accepted`,
        !ctx[ParentState.review][termsAndConditionsStep].accepted
      )
  ),
};

export const ActionTypes = getObjectKeysAsObject(actions);
